import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react'
import { RevitProvider } from './contexts/RevitContext';
import { ContentCacheProvider } from './contexts/ContentCacheContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

const queryClient = new QueryClient();

posthog.init('phc_Oj6n7Z8lK5D4yvpxKp3ACb5kHiy6043GSXu8O9YZzx4', {
  api_host: 'https://us.i.posthog.com',
  defaults: '2026-01-30'
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider 
      publishableKey={PUBLISHABLE_KEY} 
      afterSignOutUrl="/" 
      // signInUrl="/signin" 
      afterSwitchSessionUrl="/overview"
      // Enable organizations feature
      organizationFeatures={{
        enabled: true,
      }}
    >
      <ThemeProvider>
        <PostHogProvider client={posthog}>
          <QueryClientProvider client={queryClient}>
            <RevitProvider>
                <ContentCacheProvider>
                    <App />
                </ContentCacheProvider>
            </RevitProvider>
          </QueryClientProvider>
        </PostHogProvider>
      </ThemeProvider>
    </ClerkProvider>
  </React.StrictMode>
);

reportWebVitals();
